import ReactDOM from 'react-dom';
import { PrincipalsSignupSurvey } from './PrincipalsSignupSurvey.js';
import { detectLocation } from '../common/detectLocation.js';


/* global userObj */ // general/userInfo.js

export const principalsSignupFormMain = () => {
    const isSignedIn = false;
    const email = (userObj && userObj.email) ? userObj.email : '';
    const fullName = (userObj && userObj.fullName) ? decodeURIComponent(userObj.fullName) : '';
    const principalRole = false;
    var principalsSignupForm = ReactDOM.render(
        <PrincipalsSignupSurvey
            isSignedIn={isSignedIn}
            email={email}
            fullName={fullName}
            principalRole={principalRole}
            loading={false}
            disabled={true}
        />,
        document.getElementById('principals-signup-form-main'),
    );

    detectLocation(principalsSignupForm.setLocation, true);
};
